import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Inbox,
  Users,
  Tag,
  BarChart3,
  Settings,
  Headset,
  Rocket,
} from 'lucide-react';
import { CURRENT_VERSION } from '../lib/changelog';
import { useNotificationsStore } from '../lib/notifications-store';

const NAV_ITEMS = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true, badgeKey: null as 'unread' | null },
  { to: '/admin/tickets', label: 'Tickets', icon: Inbox, badgeKey: 'unread' as 'unread' | null },
  { to: '/admin/customers', label: 'Clientes', icon: Users, badgeKey: null as 'unread' | null },
  { to: '/admin/categories', label: 'Categorías', icon: Tag, badgeKey: null as 'unread' | null },
  { to: '/admin/reports', label: 'Reportes', icon: BarChart3, badgeKey: null as 'unread' | null },
  { to: '/admin/settings', label: 'Configuración', icon: Settings, badgeKey: null as 'unread' | null },
];

export function Sidebar() {
  const unreadCount = useNotificationsStore((s) => s.unreadCount);
  return (
    <aside className="hidden md:flex w-60 shrink-0 flex-col border-r border-slate-200 bg-white">
      <div className="h-16 flex items-center gap-2.5 px-5 border-b border-slate-100">
        <div className="h-8 w-8 rounded-lg bg-slate-900 grid place-items-center text-white">
          <Headset size={16} />
        </div>
        <div className="leading-tight">
          <div className="text-sm font-semibold tracking-tight">Vipsoft</div>
          <div className="text-[11px] text-slate-500">Soporte</div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-0.5">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm transition ${
                isActive
                  ? 'bg-slate-900 text-white'
                  : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
              }`
            }
          >
            <span className="flex items-center gap-2.5">
              <item.icon size={16} />
              {item.label}
            </span>
            {item.badgeKey === 'unread' && unreadCount > 0 && (
              <span className="text-[11px] font-medium px-1.5 py-0.5 rounded bg-rose-500 text-white min-w-[20px] text-center">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-slate-100 space-y-3">
        <NavLink
          to="/admin/changelog"
          className={({ isActive }) =>
            `flex items-center justify-between gap-3 px-3 py-2 rounded-lg text-sm transition ${
              isActive
                ? 'bg-amber-50 text-amber-700'
                : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
            }`
          }
          title="Historial de mejoras del sistema"
        >
          <span className="flex items-center gap-2.5 font-medium">
            <Rocket size={16} />
            Mejoras
          </span>
          <span className="text-[10px] font-mono tracking-wider px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">
            v{CURRENT_VERSION}
          </span>
        </NavLink>

      </div>
    </aside>
  );
}
